import React, { useState, useEffect } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { apiService } from '../../constants/ApiService';
import { resetToken } from '../../reducetool/features/authSlice';
import { allRemoveItem } from '../../reducetool/features/cardSlice';
import AddressModal from './AddressModal';

const SavedAddresses = () => {
    const navigate = useNavigate();
    const authData = useSelector(state => state.authState);
    const initialNewAddress = {
        id: 0,
        userId: authData.user_id,
        m_form_name: '',
        m_address: '',
        m_city: '',
        m_pin_code: '',
        m_country: '',
        m_address_type: ''
    }
    const [editMode, setEditMode] = useState(false);
    const [userDetail, setUserDetail] = useState({});
    const [userMultipleAddress, setUserMultipleAddress] = useState([])
    const [editAddressMode, setEditAddressMode] = useState(false)
    const [newAddressData, setNewAddressData] = useState(initialNewAddress);
    const [isAddingAddress, setIsAddingAddress] = useState(false);
    
    const [errorAddressData, setErrorAddressData] = useState({});

    
    useEffect(() => {

        if (authData.login) {
            getUserMultipleAddress()
        }
    }, []);

    const getUserMultipleAddress = async () => {
        try {

            let config = {
                headers: {
                    'Content-Type': 'application/json',
                    'accept': 'application/json',
                    'User_id': newAddressData.userId
                }
            };

            const response = await apiService.get(`/api/admin/User_Detail/GetUserMultiAddress`, config)

            if (response.response && response.response.data.errors) {
                console.log(response.response?.data?.errors)
            }
            if (response.status === true) {
                // console.log(response.multiUserAddData)

                setUserMultipleAddress(response.multiUserAddData)
            }
            else {
                // console.log(response.message);
            }
        } catch (error) {
            console.log(error)
            console.log('SomeThing went wrong!!');
        }
    }


    const onHanldeNewAddress = () => {
        setEditAddressMode(true)
        setIsAddingAddress(true)
    }

    const onHandleDeleteAddress = async (id) => {

        const isDeleteConfirmed = window.confirm('Are you sure you want to delete this address?');
        if (isDeleteConfirmed) {
            try {
                let config = {
                    headers: {
                        'Content-Type': 'application/json', // Important for file upload//s
                        'accept': 'application/json'
                    }
                };

                const response = await apiService.delete(`/api/admin/User_Detail/DeletUserMulAdd?id=${id}`, config)
                if (response.response && response.response.data.errors) {
                    console.log(response.response?.data?.errors)
                }

                if (response.status === true) {
                    console.log(response.message);
                    getUserMultipleAddress()
                }
                else {
                    alert(response.message);
                }
            } catch (error) {
                console.log(error)
                alert('SomeThing went wrong!!');
            }
        } else {
            console.log('Deletion canceled.');
        }
    };

    const onHandleUpdateAddress = (id) => {
        let findArray = userMultipleAddress.find((data) => data.id === id)
        setNewAddressData(findArray)
        setEditAddressMode(true)
        setIsAddingAddress(false)
    }
    const onChangeHandle = (e) => {
        //console.log("run the function for chnag the valeie")
        const { name, value, type } = e.target;

        setUserDetail((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleAddAddress = async () => {

        let validate = await validateForm()
        if (!validate) {
            return
        }

        try {

            let config = {
                headers: {
                    'Content-Type': 'application/json',
                    'accept': 'application/json'
                }
            };
            const response = await apiService.post(`/api/admin/User_Detail/AddMultiAddress`, newAddressData, config)
            if (response.response && response.response.data.errors) {
                console.log(response.response?.data?.errors)
            }
            if (response.status === true) {
                console.log("Add New Address");
                setNewAddressData(initialNewAddress)
                getUserMultipleAddress()
                setEditAddressMode(false)
            }
            else {
                console.log(response);
            }
        } catch (error) {
            console.log(error)
            console.log('SomeThing went wrong!!');
        }
    };

    const handleUpdateAddAddress = async () => {


        let validate = await validateForm()
        if (!validate) {
            return
        }
        try {

            let config = {
                headers: {
                    'Content-Type': 'application/json',
                    'accept': 'application/json'
                }
            };

            const response = await apiService.put(`/api/admin/User_Detail/UpdateUserMultiAdd?id=${newAddressData.id}`, newAddressData, config)

            if (response.response && response.response.data.errors) {
                console.log(response.response?.data?.errors)
            }
            if (response.status === true) {
                console.log(response.message);
                setNewAddressData(initialNewAddress)
                setEditAddressMode(false)
                getUserMultipleAddress()
            }
            else {
                console.log(response.message);
            }
        } catch (error) {
            console.log(error)
            console.log('SomeThing went wrong!!');
        }
    };

    
    const validateForm = () => {
        const errors = {};

        if (!newAddressData.m_form_name) {
            errors.m_form_name = "Name is required";
        }

        if (!newAddressData.m_address) {
            errors.m_address = "Address is required";
        }

        if (!newAddressData.m_city) {
            errors.m_city = "City is required";
        }

        if (!newAddressData.m_pin_code) {
            errors.m_pin_code = "Pin code is required";
        }

        if (!newAddressData.m_country) {
            errors.m_country = "Country is required";
        }

        if (!newAddressData.m_address_type) {
            errors.m_address_type = "Address type is required";
        }

        setErrorAddressData(errors)
        return Object.keys(errors).length === 0;
    };

    const handleEditConfirm = () => {
        setEditAddressMode(false);
        setNewAddressData(initialNewAddress)
        setErrorAddressData({})
    };

    
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setNewAddressData(prevData => ({
            ...prevData,
            [name]: value
        }));
    };

    return(
        <>
            <section className="user-dashboard-section section-b-space">
                    <div className="container-fluid-lg">
                        <div className="row">
                            <div className="col-xxl-12 col-lg-12">  
                            <div className="dashboard-address">
                                            <div className="title title-flex">
                                                <div>
                                                    <h2>Saved Addresses</h2>
                                                    <span className="title-leaf">
                                                        <svg className="icon-width bg-gray">
                                                            <use xlinkHref="../assets/svg/leaf.svg#leaf" />
                                                        </svg>
                                                    </span>
                                                </div>
                                                <button
                                                    className="btn theme-bg-color text-white fw-bold mt-lg-0 mt-3"
                                                    onClick={() => { onHanldeNewAddress() }}
                                                >
                                                    <i data-feather="plus" className="me-2" /> Add New Address
                                                </button>
                                            </div>

                                            <div className="row g-sm-4 g-3">

                                                {userMultipleAddress.length != 0 ?
                                                    <>
                                                        {userMultipleAddress.map((key, index) => (
                                                            <>
                                                                <div className="col-xxl-6 col-xl-6 col-lg-12 col-md-6">
                                                                    <div className="address-box">
                                                                        <div>
                                                                            <div className="form-check">
                                                                                <input
                                                                                    className="form-check-input"
                                                                                    type="radio"
                                                                                    name="jack"
                                                                                    id={`flexRadioDefault${index}`}
                                                                                    defaultChecked=""
                                                                                />
                                                                            </div>
                                                                            <div className="label">
                                                                                <label>{key.m_address_type}</label>
                                                                            </div>

                                                                            <div className="table-responsive address-table">
                                                                                <table className="table">
                                                                                    <tbody>
                                                                                        <tr>
                                                                                            <td colSpan={2}>
                                                                                                <input type='text'
                                                                                                    disabled={!editMode}
                                                                                                    style={{ border: editMode ? '1px solid black' : '0', backgroundColor: "transparent" }}
                                                                                                    value={key.m_form_name}
                                                                                                    id={`m_form_name_${index}`}
                                                                                                    name={`m_form_name_${index}`}
                                                                                                    onChange={onChangeHandle}
                                                                                                />
                                                                                            </td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>Address :</td>
                                                                                            <td>
                                                                                                <input type='text'
                                                                                                    disabled={!editMode}
                                                                                                    style={{ border: editMode ? '1px solid black' : '0', backgroundColor: "transparent" }}
                                                                                                    value={key.m_address}
                                                                                                    id={`m_address_${index}`}
                                                                                                    name={`m_address_${index}`}
                                                                                                    onChange={onChangeHandle}
                                                                                                />
                                                                                            </td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>Pin Code :</td>
                                                                                            <td>
                                                                                                <input type='text'
                                                                                                    disabled={!editMode}
                                                                                                    style={{ border: editMode ? '1px solid black' : '0', backgroundColor: "transparent" }}
                                                                                                    value={key.m_pin_code}
                                                                                                    id={`m_pin_code_${index}`}
                                                                                                    name={`m_pin_code_${index}`}
                                                                                                    onChange={onChangeHandle}
                                                                                                />
                                                                                            </td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>City:</td>
                                                                                            <td>
                                                                                                <input type='text'
                                                                                                    disabled={!editMode}
                                                                                                    style={{ border: editMode ? '1px solid black' : '0', backgroundColor: "transparent" }}
                                                                                                    value={key.m_city}
                                                                                                    id={`m_city_${index}`}
                                                                                                    name={`m_city_${index}`}
                                                                                                    onChange={onChangeHandle}
                                                                                                />
                                                                                            </td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>Country :</td>
                                                                                            <td>
                                                                                                <input type='text'
                                                                                                    disabled={!editMode}
                                                                                                    style={{ border: editMode ? '1px solid black' : '0', backgroundColor: "transparent" }}
                                                                                                    value={key.m_country}
                                                                                                    id={`m_country_${index}`}
                                                                                                    name={`m_country_${index}`}
                                                                                                    onChange={onChangeHandle}
                                                                                                />
                                                                                            </td>
                                                                                        </tr>
                                                                                    </tbody>
                                                                                </table>
                                                                            </div>
                                                                        </div>
                                                                        <div className="button-group">
                                                                            <button
                                                                                className="btn btn-sm add-button btn-success w-100"
                                                                                onClick={() => onHandleUpdateAddress(key.id)}
                                                                            >
                                                                                <span>
                                                                                <i className="fa fa-edit mr-2" /> 
                                                                                Edit
                                                                                </span>
                                                                            </button>
                                                                            <button
                                                                                className="btn btn-sm btn-danger w-100"
                                                                                onClick={() => onHandleDeleteAddress(key.id)}
                                                                            >
                                                                                <i className="fa fa-trash" />
                                                                                Remove
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        ))}
                                                    </>
                                                    :
                                                    <>
                                                        <h6>No addresses found</h6>
                                                    </>
                                                }

                                            </div>
                                        </div>
                            </div> 
                        </div>
                    </div>
            </section>

            {editAddressMode &&
                <AddressModal
                    handleInputChange={handleInputChange}
                    newAddressData={newAddressData}
                    handleEditConfirm={handleEditConfirm}
                    handleUpdateAddAddress={handleUpdateAddAddress}
                    isAddingAddress={isAddingAddress}
                    handleAddAddress={handleAddAddress}
                    errorAddressData={errorAddressData}
                />}
        </>)
}

export default SavedAddresses;